/**
 * Enum for data source types
 */
export enum DataType {
  /**
   * GeoJSON data (default)
   */
  GEOJSON = 'geojson',

  /**
   * Galigeo FeatureServer service URL
   * Data will be fetched dynamically based on map extent
   */
  GALIGEO_SERVICE = 'galigeo-service',
}
